<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header">
        <a class="logo" [routerLink]="['/']">
            <img class="logo-image" [src]="menuTheme() === 'light' ? '/layout/images/logo-dark.svg' : '/layout/images/logo-white.svg'" alt="diamond-layout" />
            <span class="app-name title-h7">EXPRESS ERP</span>
        </a>
        <button class="layout-sidebar-anchor z-2" type="button" (click)="onAnchorToggle()"></button>
    </div>

    <div #menuContainer class="layout-menu-container" (scroll)="onMenuScroll()">
        <div app-menu></div>
    </div>
    <div app-topbar *ngIf="isHorizontal()"></div>
</div>
